import { render, staticRenderFns } from "./FillAttrsItem.vue?vue&type=template&id=64512810&"
import script from "./FillAttrsItem.vue?vue&type=script&lang=js&"
export * from "./FillAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/items/FillAttrsItem.vue"
export default component.exports